import { InjectionToken } from '@angular/core'

export const CURRENT_ORG_ID: InjectionToken<number> = new InjectionToken<number>('currentOrgId', {
  providedIn: 'root',
  factory: () => parseInt(((/\/organization:(\d+)/.exec(window.location.pathname)) || [])[1], 10) || undefined
})
